import React, { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./style.css";
import logo from "../../../../redcliffe_logo.jpeg";
// import imagelogo from "./logo_RCL.png";
import DocterSignature from "./prabhakar-signature.png";
import DocterSignature2 from "./nakul-signature.png";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { Grid, MenuItem, Paper, TableBody, TextField, colors } from "@mui/material";
import { Image } from "@progress/kendo-drawing/dist/npm/drawing";
import { MultilineChart } from "@material-ui/icons";
import moment from "moment";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import NpsRating from "../../NPS";
// import asset from "./Asset 8.png";
const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const HlaReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const [uuid, setUuid] = useState();
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);
    //Report Data
    const [hla, sethla] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        sethla(data);
    }, [reportListParameter])


    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])

    //Booking Data
    const [hlaReport, sethlaReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        sethlaReport(data);
    }, [reportListParameter])


    useEffect(() => {
        setSample_Collected(hlaReport[0]?.collection_date);
        setSample_Receivedtime(hlaReport[0]?.pickup_time);
        setdesignation(hlaReport[0]?.designation);
        setGender(hlaReport[0]?.customer_gender);
        setSample_Received(hlaReport[0]?.pickup_date);
        setName(hlaReport[0]?.customer_name);
        setAge(hlaReport[0]?.customer_age);
        setDob(hlaReport[0]?.dob);
        setUuid(hlaReport[0]?.uuid)
    }, [hlaReport]);

    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);

        }
        else {

            setAge(hlaReport[0]?.customer_age);
        }
    }, [dob]);



    //Test Information
    // const [information, setinformation] = useState<any>([]);
    // useEffect(() => {
    //     const Tinformation: any = [];
    //     if (reportListParameter &&
    //         reportListParameter?.test_information &&
    //         reportListParameter?.test_information?.length > 0
    //     ) {
    //         reportListParameter?.test_information?.map((list: any) => {
    //             Tinformation?.push({ ...list });
    //         });
    //     }
    //     setinformation(Tinformation);
    // }, [reportListParameter]);

    // const updateInformation = (
    //     id: number,
    //     value: any,
    //     index: number,
    //     key: string,
    //     object: any
    // ) => {
    //     let storeData = [...information]
    //     let newItem = object;
    //     switch (key) {
    //         case "free_text":
    //             newItem.parameter_value = value
    //             break;
    //     }
    //     storeData[index] = newItem;
    //     setinformation(storeData);
    // }

    //Clinical indication
    const [hlaClinData, sethlaClinData] = useState<any>([]);
    useEffect(() => {
        const hlaclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_indication &&
            reportListParameter?.clinical_indication?.length > 0
        ) {
            reportListParameter?.clinical_indication?.map((list: any) => {
                hlaclincdata?.push({ ...list });
            });
        }
        sethlaClinData(hlaclincdata);
    }, [reportListParameter]);

    const updateClientIndication = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...hlaClinData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        sethlaClinData(storeData);
    }



    //Result Summary
    let ResultData = [
        {
            id: 1,
            name: "Patient",
            nameid: "",
            status: "Complete",
            matchingRation: "",
            Mismatchedlocus: "",
        },
        {
            id: 1,
            name: "Donor",
            nameid: "",
            status: "Complete",
            matchingRation: "",
            Mismatchedlocus: "",
        }
    ];
    const [Result, setResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca
            &&
            reportListParameter?.result_brca
                .length > 0
        ) {
            reportListParameter?.result_brca
                ?.map((list: any) => {
                    storeData.push({ ...list });
                });
        }
        setResult(storeData);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([]);

    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca
            &&
            reportListParameter?.result_brca
                .length > 0
        ) {
            data = reportListParameter?.result_brca
            [0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                ResultData?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setTableData(storeData);

    }, [reportListParameter]);
    const updateRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "nameid":
                newItem.nameid = value;
                break;
            case "status":
                newItem.status = value;
                break;
            case "matchingRation":
                newItem.matchingRation = value;
                break;
            case "Mismatchedlocus":
                newItem.Mismatchedlocus = value;
                break;
        }
        storeData[index] = newItem;
        setTableData(storeData);
    };

    // Result Remark
    const [resultRemark, setresultRemarks] = useState<any>([]);
    useEffect(() => {
        const remark: any = [];
        if (
            reportListParameter &&
            reportListParameter?.remarks1 &&
            reportListParameter?.remarks1?.length > 0
        ) {
            reportListParameter?.remarks1?.map((list: any) => {
                remark?.push({ ...list });
            });
        }
        setresultRemarks(remark);
    }, [reportListParameter]);

    const updateRemark = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...resultRemark]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setresultRemarks(storeData);
    }


    //PATIENT HLA TYPING REPORT

    let patienthla = [
        {
            id: 1,
            name: "Allele 1",
            hla_a: "",
            hla_b: "",
            hla_c: "",
            hla_drb1: "",
            hla_dqb1: "",
            hla_dpb1: "",
        },
        {
            id: 2,
            name: "Allele 2",
            hla_a: "",
            hla_b: "",
            hla_c: "",
            hla_drb1: "",
            hla_dqb1: "",
            hla_dpb1: "",
        }
    ];
    const [patientResult, setpatientResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.patient_hla_report &&
            reportListParameter?.patient_hla_report.length > 0
        ) {
            reportListParameter?.patient_hla_report?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setpatientResult(storeData);
    }, [reportListParameter]);

    const [patienttableData, setpatientTableData] = useState<any>([]);

    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.patient_hla_report &&
            reportListParameter?.patient_hla_report.length > 0
        ) {
            data = reportListParameter?.patient_hla_report[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                patienthla?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setpatientTableData(storeData);

    }, [reportListParameter]);
    const updatePatienthla = (index: number, key: string, value: any, object: any) => {
        let storeData = [...patienttableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "hla_a":
                newItem.hla_a = value;
                break;
            case "hla_b":
                newItem.hla_b = value;
                break;
            case "hla_c":
                newItem.hla_c = value;
                break;
            case "hla_drb1":
                newItem.hla_drb1 = value;
                break;
            case "hla_dqb1":
                newItem.hla_dqb1 = value;
                break;
            case "hla_dpb1":
                newItem.hla_dpb1 = value;
                break;
        }
        storeData[index] = newItem;
        setpatientTableData(storeData);
    };


    // TYPING STATUS PATIENT
    let p = [
        {
            id: 1,
            name: "Typing Status :",
            values: "Complete",

        }
    ]
    const [ptstatus, setptstatus] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.status1 &&
            reportListParameter?.status1.length > 0
        ) {
            reportListParameter?.status1?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setptstatus(storeData);
    }, [reportListParameter]);

    const [pstatus, setpstatus] = useState<any>([]);
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.status1 &&
            reportListParameter?.status1.length > 0
        ) {
            data = reportListParameter?.status1[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                p?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setpstatus(storeData);

    }, [reportListParameter]);
    const updatePstatus = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any
    ) => {
        let storeData = [...pstatus]
        let newItem = object;
        switch (key) {
            case "name":
                newItem.name = value
                break;
            case "values":
                newItem.values = value
        }
        storeData[index] = newItem;
        setpstatus(storeData);
    }


    //DONOR DETAILS LINE 1
    let d = [
        {
            id: 1,
            sampleid: "NA",
            name: "NA",
            claimed_relation: "NA",
            specimen: "NA",
        }
    ];
    const [donorde1, setdonorde1] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result1
            &&
            reportListParameter?.result1
                .length > 0
        ) {
            reportListParameter?.result1
                ?.map((list: any) => {
                    storeData.push({ ...list });
                });
        }
        setdonorde1(storeData);
    }, [reportListParameter]);

    const [donord1, setdonord1] = useState<any>([]);

    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result1
            &&
            reportListParameter?.result1
                .length > 0
        ) {
            data = reportListParameter?.result1
            [0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                d?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setdonord1(storeData);
    }, [reportListParameter]);

    const updateD1 = (index: number, key: string, value: any, object: any) => {
        let storeData = [...donord1];
        let newItem = storeData[index];
        switch (key) {
            case "sampleid":
                newItem.sampleid = value;
                break;
            case "name":
                newItem.name = value;
                break;
            case "claimed_relation":
                newItem.claimed_relation = value;
                break;
            case "specimen":
                newItem.specimen = value;
                break;
        }
        storeData[index] = newItem;
        setdonord1(storeData);
    };

    // DONOR DETAILS LINE 2

    let d2 = [
        {
            id: 1,
            age: "NA",
            gender: "NA",
            srd: "NA",
            pd: "NA",
        }
    ];
    const [donorde2, setdonorde2] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result2
            &&
            reportListParameter?.result2
                .length > 0
        ) {
            reportListParameter?.result2
                ?.map((list: any) => {
                    storeData.push({ ...list });
                });
        }
        setdonorde2(storeData);
    }, [reportListParameter]);

    const [donord2, setdonord2] = useState<any>([]);

    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result2
            &&
            reportListParameter?.result2
                .length > 0
        ) {
            data = reportListParameter?.result2
            [0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                d2?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setdonord2(storeData);
    }, [reportListParameter]);

    const updateD2 = (index: number, key: string, value: any, object: any) => {
        let storeData = [...donord2];
        let newItem = storeData[index];
        switch (key) {
            case "age":
                newItem.age = value;
                break;
            case "gender":
                newItem.gender = value;
                break;
            case "srd":
                newItem.srd = value;
                break;
            case "pd":
                newItem.pd = value;
                break;
        }
        storeData[index] = newItem;
        setdonord2(storeData);
    };




    //DONOR HLA TYPING REPORT
    let Donorhla = [
        {
            id: 1,
            name: "Allele 1",
            hla_a: "",
            hla_b: "",
            hla_c: "",
            hla_drb1: "",
            hla_dqb1: "",
            hla_dpb1: "",
        },
        {
            id: 2,
            name: "Allele 2",
            hla_a: "",
            hla_b: "",
            hla_c: "",
            hla_drb1: "",
            hla_dqb1: "",
            hla_dpb1: "",
        }
    ];
    const [donorResult, setdonorResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.donor_hla_report
            &&
            reportListParameter?.donor_hla_report
                .length > 0
        ) {
            reportListParameter?.donor_hla_report
                ?.map((list: any) => {
                    storeData.push({ ...list });
                });
        }
        setdonorResult(storeData);
    }, [reportListParameter]);

    const [donortableData, setdonorTableData] = useState<any>([]);

    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.donor_hla_report
            &&
            reportListParameter?.donor_hla_report
                .length > 0
        ) {
            data = reportListParameter?.donor_hla_report
            [0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                Donorhla?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setdonorTableData(storeData);
    }, [reportListParameter]);

    const updateDonorhla = (index: number, key: string, value: any, object: any) => {
        let storeData = [...donortableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "hla_a":
                newItem.hla_a = value;
                break;
            case "hla_b":
                newItem.hla_b = value;
                break;
            case "hla_c":
                newItem.hla_c = value;
                break;
            case "hla_drb1":
                newItem.hla_drb1 = value;
                break;
            case "hla_dqb1":
                newItem.hla_dqb1 = value;
                break;
            case "hla_dpb1":
                newItem.hla_dpb1 = value;
                break;
        }
        storeData[index] = newItem;
        setdonorTableData(storeData);
    };


    //TYPING STATUS DONOR
    let D = [
        {
            id: 1,
            name: "Typing Status :",
            values: "Complete",

        }
    ]
    const [dostatus, setdostatus] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.status2 &&
            reportListParameter?.status2.length > 0
        ) {
            reportListParameter?.status2?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setdostatus(storeData);
    }, [reportListParameter]);

    const [dstatus, setdstatus] = useState<any>([]);
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.status2 &&
            reportListParameter?.status2.length > 0
        ) {
            data = reportListParameter?.status2[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                D?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setdstatus(storeData);

    }, [reportListParameter]);
    const updateDstatus = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any
    ) => {
        let storeData = [...dstatus]
        let newItem = object;
        switch (key) {
            case "name":
                newItem.name = value
                break;
            case "values":
                newItem.values = value
        }
        storeData[index] = newItem;
        setdstatus(storeData);
    }

    //MATCHING RESULTS

    let MData = [
        {
            id: 1,
            matchingratio: "",
            Mismatchedlocus: "",
        }
    ];
    const [MResult, setMResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.matching_results &&
            reportListParameter?.matching_results.length > 0
        ) {
            reportListParameter?.matching_results?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setMResult(storeData);
    }, [reportListParameter]);

    const [MtableData, setMTableData] = useState<any>([]);

    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.matching_results &&
            reportListParameter?.matching_results.length > 0
        ) {
            data = reportListParameter?.matching_results[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                MData?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setMTableData(storeData);

    }, [reportListParameter]);
    const updateMRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...MtableData];
        let newItem = storeData[index];
        switch (key) {
            case "matchingratio":
                newItem.matchingratio = value;
                break;
            case "Mismatchedlocus":
                newItem.Mismatchedlocus = value;
                break;
        }
        storeData[index] = newItem;
        setMTableData(storeData);
    };

    // DONOR Remark
    const [resultdRemark1, setresultdRemarks1] = useState<any>([]);
    useEffect(() => {
        const remark: any = [];
        if (
            reportListParameter &&
            reportListParameter?.remarks2 &&
            reportListParameter?.remarks2?.length > 0
        ) {
            reportListParameter?.remarks2?.map((list: any) => {
                remark?.push({ ...list });
            });
        }
        setresultdRemarks1(remark);
    }, [reportListParameter]);

    const updateMRemark = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...resultdRemark1]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setresultdRemarks1(storeData);
    }

    //APENDIX PATIENT

    let pdata = [
        {
            id: 1,
            name: "HLA-A",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 2,
            name: "HLA-A",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 3,
            name: "HLA-B",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 4,
            name: "HLA-B",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 5,
            name: "HLA-C",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 6,
            name: "HLA-C",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 7,
            name: "DRB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        },
        {
            id: 8,
            name: "DRB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL"
        },
        {
            id: 9,
            name: "DQB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        },
        {
            id: 10,
            name: "DQB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        }
        , {
            id: 11,
            name: "DPB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        },
        {

            id: 12,
            name: "DPB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        }

    ];
    const [patientApendix, setpatientApendix] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.patient_appendix
            &&
            reportListParameter?.patient_appendix
                .length > 0
        ) {
            reportListParameter?.patient_appendix
                ?.map((list: any) => {
                    storeData.push({ ...list });
                });
        }
        setpatientApendix(storeData);
    }, [reportListParameter]);

    const [patientAtableData, setpatientATableData] = useState<any>([]);

    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.patient_appendix
            &&
            reportListParameter?.patient_appendix
                .length > 0
        ) {
            data = reportListParameter?.patient_appendix
            [0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                pdata?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setpatientATableData(storeData);

    }, [reportListParameter]);
    const updatePatientApendix = (index: number, key: string, value: any, object: any) => {
        let storeData = [...patientAtableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "g_code":
                newItem.g_code = value;
                break;
            case "nmdpcode":
                newItem.nmdpcode = value;
                break;
            case "se_quenced":
                newItem.se_quenced = value;
                break;
            case "includeallels":
                newItem.includeallels = value;
                break;
        }
        storeData[index] = newItem;
        setpatientATableData(storeData);
    };

    //hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }

    //APENDIX DONOR

    let Ddata = [
        {
            id: 1,
            name: "HLA-A",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 2,
            name: "HLA-A",
            g_code: "_",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 3,
            name: "HLA-B",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 4,
            name: "HLA-B",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 5,
            name: "HLA-C",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 6,
            name: "HLA-C",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Full Gene",
            includeallels: "NIL",
        },
        {
            id: 7,
            name: "DRB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        },
        {
            id: 8,
            name: "DRB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL"
        },
        {
            id: 9,
            name: "DQB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        },
        {
            id: 10,
            name: "DQB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        }
        , {
            id: 11,
            name: "DPB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        },
        {

            id: 12,
            name: "DPB1",
            g_code: "-",
            nmdpcode: "-",
            se_quenced: "Exon 2,3",
            includeallels: "NIL",
        }

    ];
    const [donorApendix, setdonorApendix] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.donor_apendix &&
            reportListParameter?.donor_apendix.length > 0
        ) {
            reportListParameter?.donor_apendix?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setdonorApendix(storeData);
    }, [reportListParameter]);

    const [donorAtableData, setdonorATableData] = useState<any>([]);

    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.donor_apendix &&
            reportListParameter?.donor_apendix.length > 0
        ) {
            data = reportListParameter?.donor_apendix[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                Ddata?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setdonorATableData(storeData);

    }, [reportListParameter]);
    const updateDonorApendix = (index: number, key: string, value: any, object: any) => {
        let storeData = [...donorAtableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "g_code":
                newItem.g_code = value;
                break;
            case "nmdpcode":
                newItem.nmdpcode = value;
                break;
            case "se_quenced":
                newItem.se_quenced = value;
                break;
            case "includeallels":
                newItem.includeallels = value;
                break;
        }
        storeData[index] = newItem;
        setdonorATableData(storeData);
    };

    //SOFTWARE AND ALLELE DATABASE VERSION
    const [software, setsoftware] = useState<any>([]);
    useEffect(() => {
        const ab: any = [];
        if (reportListParameter &&
            reportListParameter?.softwere &&
            reportListParameter?.softwere?.length > 0) {
            reportListParameter?.softwere?.map((list: any) => {
                ab?.push({ ...list });
            });
        }
        setsoftware(ab);
    }, [reportListParameter]);
    const updateSoftware = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any
    ) => {
        let storeData = [...software]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setsoftware(storeData);
    }

    //DOCTOR LIST
    const [hladoctorList, sethladoctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        sethladoctorList(data);
    }, [reportListParameter]);

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hladoctorList]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        sethladoctorList(storeData);
    }
    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }
    // Hospital Id

    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }

    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }

    const submitData = async (e: any) => {
        e.preventDefault();
        let storeData: any = [];

        if (hlaReport.length > 0) {
            hlaReport?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (resultRemark.length > 0) {
            resultRemark?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (hlaClinData.length > 0) {
            hlaClinData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (software.length > 0) {
            software?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (resultdRemark1.length > 0) {
            resultdRemark1?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }


        if (hladoctorList.length > 0) {
            hladoctorList?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        const stringify = JSON.stringify(tableData);
        if (Result.length > 0) {
            Result?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        const stringify1 = JSON.stringify(patienttableData);
        if (patientResult.length > 0) {
            patientResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify1,
                });
            });
        }
        const stringify2 = JSON.stringify(donortableData);
        if (donorResult.length > 0) {
            donorResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify2,
                });
            });
        }
        const stringify3 = JSON.stringify(MtableData);
        if (MResult.length > 0) {
            MResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify3,
                });
            });
        }
        const stringify4 = JSON.stringify(patientAtableData);
        if (patientApendix.length > 0) {
            patientApendix?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify4,
                });
            });
        }
        const stringify5 = JSON.stringify(donorAtableData);
        if (donorApendix.length > 0) {
            donorApendix?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify5,
                });
            });
        }
        const stringify6 = JSON.stringify(donord1);
        if (donorde1.length > 0) {
            donorde1?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify6,
                });
            });
        }

        const stringify7 = JSON.stringify(donord2);
        if (donorde2.length > 0) {
            donorde2?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify7,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        const stringify8 = JSON.stringify(dstatus);
        if (dostatus.length > 0) {
            dostatus?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify8,
                });
            });
        }
        const stringify9 = JSON.stringify(pstatus);
        if (ptstatus.length > 0) {
            ptstatus?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify9,
                });
            });
        }


        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }
    };
    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
     const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])
    const documentTitle = `${hlaReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="page-header">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main-content4">.</div>
                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "18px", marginTop: "10px" }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="marginLeft-c">
                            <Grid item xs={3.8}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8}>
                                            : {hlaReport[0]?.pk
                                                ? hlaReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8}>
                                            : <input
                                                className="input"

                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "72%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <>
                                            <Grid item xs={3.5}>
                                                Age
                                            </Grid>
                                            {dob === "" || dob === null ? (
                                                <Grid item xs={8.5}>
                                                    :  <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                </Grid>
                                            )
                                                : (
                                                    <Grid item xs={8.5} style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}>
                                                        : {age} Y
                                                    </Grid>
                                                )}
                                        </>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {hlaReport[0]?.center?.name && hlaReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.8}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={4}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :  <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                value={Gender}
                                                onChange={(e) => setGender(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={4}>
                                            Referring Clinician
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={4}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={4}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="normal">NA</option>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="ffpe tissue block"> FFPE TISSUE BLOCK </option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    <div style={{ width: "96%", marginLeft: "18px", border: "none", background: "none" }} className="marginLeft-c">
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Performed:-{hlaReport[0]?.packages[0]?.name}</h6>
                    </div>

                    <div className="br">.</div>
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> TEST INFORMATION </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="container" style={{ background: "none", border: "none", fontSize: "17px", width: "93%", wordBreak: "break-word" }}>
                        <p style={{ wordBreak: "break-word" }}>
                            <i>Redcliffe</i>  High Resolution HLA Typing is a Next generation sequencing based high resolution identification of human leucocyte antigen(HLA) alleles. It detect match between the patient & donor in HLA regions of loci: HLA-A, HLA-B, HLA-C, HLA-DRB1, HLA-DQB1and HLA-DPB1.The aim of the test is to determine the HLA match between the donor and the recipient. Usually many donors are matched against the patient to identify the best possible match thus translating to the ideal donor.
                        </p>
                    </div>
                    <div className="br">.</div>

                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>CLINICAL INDICATION </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {hlaClinData?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={4}
                                            cols={121}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateClientIndication(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>
                    <div >
                        <h5 style={{ color: "rgb(28, 78, 128)", marginLeft: "45px", fontWeight: "bold" }}>
                            RESULTS SUMMARY
                        </h5>
                    </div>
                    <div>
                        <div
                            style={{
                                width: "93%",
                                display: "flex",
                                margin: "10px 0px",
                                textAlign: "start",
                                marginLeft: "40px",
                                height: "50px",
                                background: "rgb(22 55 88)",
                                color: "white",
                                fontSize: "17px",
                                padding: "8px",

                            }}
                        //   className="marginLeft-c"
                        >   <div style={{ width: "15%" }}></div>
                            <div style={{ width: "17%", textAlign: "center" }}>
                                NAME & IDs
                            </div>

                            <div style={{ width: "20%", textAlign: "center" }}>
                                HLA Typing Status</div>

                            <div style={{ width: "25%", textAlign: "center" }}>
                                Matching Ratio with Patient
                            </div>
                            <div style={{ width: "20%", textAlign: "center" }}>
                                Matched Locus
                            </div>
                        </div>
                        <div className="result" style={{ borderLeft: "1px solid ", width: "93%", marginLeft: '40px', marginTop: '-10px' }} >
                            {tableData?.length > 0 &&
                                tableData?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    margin: "0px 0px",
                                                    fontSize: "14px",
                                                    height: "65px",
                                                    borderLeft: "1px solid"

                                                }}
                                            >
                                                <div style={{ width: "15%", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "90%", fontWeight: "bold", marginLeft: "3px", marginTop: "7px", textAlign: "center" }}
                                                            value={list?.name}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "name", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>

                                                <div
                                                    style={{ width: "18%", textAlign: "left", borderBottom: "1px solid black", borderRight: "1px solid black" }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", padding: "3px" }}
                                                            value={list?.nameid}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "nameid", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "20%", borderBottom: "1px solid black", textAlign: "left", borderRight: "1px solid black", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", padding: "3px" }}
                                                            value={list?.status}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "status", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "24%", borderBottom: "1px solid black", textAlign: "left", borderRight: "1px solid black" }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", padding: "3px" }}
                                                            value={list?.matchingRation}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "matchingRation", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "25%", borderBottom: "1px solid black", textAlign: "left", borderRight: "1px solid black" }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <textarea
                                                            style={{ border: "none", resize: "none", fontSize: "15px", textAlign: "center", background: "none" }}
                                                            rows={3}
                                                            cols={32}
                                                            value={list?.Mismatchedlocus}
                                                            contentEditable={true}
                                                            onChange={(e) =>
                                                                updateRow(
                                                                    index,
                                                                    "Mismatchedlocus",
                                                                    e.target.value,
                                                                    list
                                                                )
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                            </div>

                                        </>
                                    );
                                })}
                        </div>
                    </div>

                    {/* RESULT REMARK */}
                    <div className="br">.</div>
                    <div>
                        {resultRemark?.map((list: any, index: number) => {
                            return (

                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ resize: "none", marginLeft: "25px", paddingTop: "6px", height: "40px", border: "1px solid black" }}
                                            rows={1}
                                            cols={137}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateRemark(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>

                            )
                        })}
                    </div>
                    <div>

                    </div>
                    <div className="hmain-content3">.</div>
                    <div
                        style={{
                            width: "95%",
                            display: "flex",
                            alignItems: "center",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginTop: "10px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{
                                                width: "100px",
                                                height: "60px",
                                                marginLeft: "60px",
                                            }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div className="br"></div>
                    <div
                        style={{
                            width: "98%",
                            display: "flex",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginLeft: "12px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{
                                                border: "none",
                                                resize: "none",
                                                textAlign: "center",
                                            }}
                                            rows={4}
                                            cols={130}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </>
                                );
                            })}
                    </div>

                    <div className="main-content2">.</div>
                    {/* <div className="main-content3">.</div> */}
                    <div className="br1">.</div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{hlaReport[0]?.designation}&nbsp;{hlaReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{hlaReport[0]?.pk}
                    </div>
                    <div className="br">.</div>

                    {/* PATIENT HLA TYPING REPORT */}
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>PATIENT:HLA TYPING REPORT</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    <table className="cont" style={{ background: "none", border: "1px solid", borderBottom: "none", width: "93%", marginLeft: "40px" }}>

                        <tr >
                            <th style={{ textAlign: "center", background: "#e8f8ff", height: "40px", color: "darkblue", fontSize: "18px", borderBottom: "1px solid", columnSpan: "none" }}>
                                DETAILED PATIENT HIGH RESOLUTION HLA TYPING RESULTS
                            </th>

                        </tr>

                        <div style={{ width: "100%" }}>

                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    textAlign: "center",
                                    height: "40px",
                                    borderBottom: "1px solid black",
                                    marginLeft: "0px"

                                }}
                            >
                                <div style={{ width: "15%", borderRight: "1px solid" }}></div>
                                <div style={{ width: "15%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-A
                                </div>

                                <div style={{ width: "14%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-B</div>

                                <div style={{ width: "14%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-C
                                </div>
                                <div style={{ width: "14%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-DRB1
                                </div>
                                <div style={{ width: "14%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-DQB1
                                </div>
                                <div style={{ width: "14%", fontWeight: "bold", padding: "7px" }}>
                                    HLA-DPB1
                                </div>
                            </div>

                            {patienttableData?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                margin: "0px 0px",
                                                fontSize: "14px",
                                                height: "40px",
                                                textAlign: "center",

                                            }}
                                        >
                                            <div style={{ width: "15%", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginTop: "7px", textAlign: "center", fontWeight: "bold" }}
                                                        value={list?.name}
                                                        onChange={(e: any) =>
                                                            updatePatienthla(index, "name", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div style={{ width: "15%", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_a}
                                                        onChange={(e: any) =>
                                                            updatePatienthla(index, "hla_a", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_b}
                                                        onChange={(e: any) =>
                                                            updatePatienthla(index, "hla_b", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_c}
                                                        onChange={(e: any) =>
                                                            updatePatienthla(index, "hla_c", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_drb1}
                                                        onChange={(e: any) =>
                                                            updatePatienthla(index, "hla_drb1", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_dqb1}
                                                        onChange={(e: any) =>
                                                            updatePatienthla(index, "hla_dqb1", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_dpb1}
                                                        onChange={(e: any) =>
                                                            updatePatienthla(index, "hla_dpb1", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        </div>

                                    </>
                                );
                            })}
                        </div>
                    </table>

                    {/* TYPING STATUS PATIENT */}

                    <div style={{ border: "1px solid black", width: "93%", marginLeft: "40px", height: "40px" }}>
                        {pstatus?.length > 0 &&
                            pstatus?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                width: "95%",
                                                display: "flex",
                                                margin: "10px 0px",
                                                fontSize: "14px",
                                                height: "40px",
                                                textAlign: "center",
                                            }}
                                        >
                                            <div style={{ width: "20%", }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginTop: "-7px", textAlign: "center", fontWeight: "bold" }}
                                                        value={list?.name}
                                                        onChange={(e: any) =>
                                                            updatePstatus(list?.id, e.target.value, index, "name", list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div style={{ width: "80%", marginLeft: 8 }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "-7px", textAlign: "center" }}
                                                        value={list?.values}
                                                        onChange={(e: any) =>
                                                            updatePstatus(list?.id, e.target.value, index, "values", list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>

                                        </div>

                                    </>
                                );
                            })}
                    </div>

                    <div className="br">.</div>

                    {/* DONOR:HLA TYPING REPORT */}
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>DONOR:HLA TYPING REPORT</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    {/* DONOR DETAILS LINE 1 */}

                    <div style={{ width: "93%", marginLeft: "30px" }}>

                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                textAlign: "center",
                                height: "32px",
                                padding: "4px",
                                borderBottom: "1px solid black",
                                marginLeft: "10px",
                                background: "#e8f8ff",
                                color: "rgb(22, 55, 88)"

                            }}
                        >

                            <div style={{ width: "20%", fontWeight: "bold", }}>
                                SampleID
                            </div>
                            <div style={{ width: "30%", fontWeight: "bold", }}>
                                Name
                            </div>
                            <div style={{ width: "30%", fontWeight: "bold", }}>
                                Claimed Relationship / Relation to
                                patient
                            </div>
                            <div style={{ width: "20%", fontWeight: "bold", }}>
                                Specimen Type
                            </div>
                        </div>
                        {donord1?.length > 0 &&
                            donord1?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                width: "93%",
                                                display: "flex",
                                                margin: "10px -10px",
                                                fontSize: "14px",
                                                height: "30px",
                                                textAlign: "center",
                                                marginLeft: "0px"
                                            }}
                                        >
                                            <div style={{ width: "20%", marginLeft: 8 }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.sampleid}
                                                        onChange={(e: any) =>
                                                            updateD1(index, "sampleid", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div style={{ width: "30%", marginLeft: "25px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.name}
                                                        onChange={(e: any) =>
                                                            updateD1(index, "name", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "30%", textAlign: "left", }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", marginLeft: "20px" }}
                                                        value={list?.claimed_relation}
                                                        onChange={(e: any) =>
                                                            updateD1(index, "claimed_relation", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "20%", textAlign: "left" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", marginLeft: "70px" }}
                                                        value={list?.specimen}
                                                        onChange={(e: any) =>
                                                            updateD1(index, "specimen", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>

                                        </div>

                                    </>
                                );
                            })}

                    </div>
                    {/* DONOR DETAILS LINE 2 */}

                    <div style={{ width: "93%", marginLeft: "30px" }}>
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                textAlign: "center",
                                height: "32px",
                                padding: "4px",
                                borderBottom: "1px solid black",
                                marginLeft: "10px",
                                background: "#e8f8ff",
                                color: "rgb(22, 55, 88)"

                            }}
                        >
                            <div style={{ width: "19%", fontWeight: "bold", }}>
                                Age
                            </div>
                            <div style={{ width: "31%", fontWeight: "bold", }}>
                                Gender
                            </div>
                            <div style={{ width: "30%", fontWeight: "bold", }}>
                                Sample Receiving Date
                            </div>
                            <div style={{ width: "20%", fontWeight: "bold", }}>
                                Reporting Date
                            </div>
                        </div>

                        {donord2?.length > 0 &&
                            donord2?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                width: "93%",
                                                display: "flex",
                                                margin: "10px -10px",
                                                fontSize: "14px",
                                                height: "30px",
                                                textAlign: "center",
                                                marginLeft: "10px"
                                            }}
                                        >
                                            <div style={{ width: "20%" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.age}
                                                        onChange={(e: any) =>
                                                            updateD2(index, "age", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div style={{ width: "40%" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.gender}
                                                        onChange={(e: any) =>
                                                            updateD2(index, "gender", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "30%", textAlign: "left" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.srd}
                                                        onChange={(e: any) =>
                                                            updateD2(index, "srd", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "20%", textAlign: "left" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", marginLeft: "60px" }}
                                                        value={list?.pd}
                                                        onChange={(e: any) =>
                                                            updateD2(index, "pd", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>

                                        </div>

                                    </>
                                );
                            })}

                    </div>


                    {/* DONER HLA TYPING REPORT */}
                    <table className="cont" style={{ background: "none", border: "1px solid", borderBottom: "none", width: "93%", marginLeft: "40px" }}>

                        <tr >
                            <th style={{ textAlign: "center", background: "#e8f8ff", height: "40px", color: "darkblue", fontSize: "18px", borderBottom: "1px solid", columnSpan: "none" }}>
                                DETAILED DONOR HIGH RESOLUTION HLA TYPING RESULTS
                            </th>

                        </tr>

                        <div style={{ width: "100%" }}>

                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    textAlign: "center",
                                    height: "40px",
                                    borderBottom: "1px solid black",
                                    marginLeft: "0px",



                                }}
                            >
                                <div style={{ width: "15%", borderRight: "1px solid", padding: "4px" }}></div>
                                <div style={{ width: "15%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-A
                                </div>

                                <div style={{ width: "14%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-B</div>

                                <div style={{ width: "14%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-C
                                </div>
                                <div style={{ width: "14%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-DRB1
                                </div>
                                <div style={{ width: "14%", fontWeight: "bold", borderRight: "1px solid", padding: "7px" }}>
                                    HLA-DQB1
                                </div>
                                <div style={{ width: "14%", fontWeight: "bold", padding: "7px" }}>
                                    HLA-DPB1
                                </div>
                            </div>

                            {donortableData?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                margin: "0px 0px",
                                                fontSize: "14px",
                                                height: "40px",
                                                textAlign: "center",

                                            }}
                                        >
                                            <div style={{ width: "15%", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", fontWeight: "bold" }}
                                                        value={list?.name}
                                                        onChange={(e: any) =>
                                                            updateDonorhla(index, "name", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div style={{ width: "15%", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_a}
                                                        onChange={(e: any) =>
                                                            updateDonorhla(index, "hla_a", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_b}
                                                        onChange={(e: any) =>
                                                            updateDonorhla(index, "hla_b", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_c}
                                                        onChange={(e: any) =>
                                                            updateDonorhla(index, "hla_c", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_drb1}
                                                        onChange={(e: any) =>
                                                            updateDonorhla(index, "hla_drb1", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderRight: "1px solid black", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_dqb1}
                                                        onChange={(e: any) =>
                                                            updateDonorhla(index, "hla_dqb1", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "14%", textAlign: "left", borderBottom: "1px solid black", padding: "3px" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.hla_dpb1}
                                                        onChange={(e: any) =>
                                                            updateDonorhla(index, "hla_dpb1", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        </div>

                                    </>
                                );
                            })}
                        </div >
                    </table>

                    {/* PATIENT:HLA TYPING STSTUS */}
                    <div style={{ border: "1px solid black", width: "93%", marginLeft: "40px", height: "40px" }}>
                        {dstatus?.length > 0 &&
                            dstatus?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                width: "95%",
                                                display: "flex",
                                                margin: "10px -10px",
                                                fontSize: "14px",
                                                height: "40px",
                                                textAlign: "center",
                                            }}
                                        >
                                            <div style={{ width: "20%", marginLeft: 8 }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{
                                                            border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "-7px", textAlign: "center"
                                                            , fontWeight: "bold"
                                                        }}
                                                        value={list?.name}
                                                        onChange={(e: any) =>
                                                            updateDstatus(list?.id, e.target.value, index, "name", list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div style={{ width: "80%", marginLeft: 8 }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "-7px", textAlign: "center" }}
                                                        value={list?.values}
                                                        onChange={(e: any) =>
                                                            updateDstatus(list?.id, e.target.value, index, "values", list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                    </div>


                    {/* MATCHING RESULT */}

                    <table style={{ width: "93%", marginLeft: "40px", height: "120px", border: "1px solid black" }}>
                        <div style={{ border: "1px solid black ", background: "rgb(22 55 88)", color: "white", textAlign: "center", fontWeight: "bold", height: "30px", fontSize: "18px" }}>Matching Result</div>

                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                textAlign: "center",
                                height: "40px",
                                borderBottom: "1px solid black",


                            }}
                        >
                            <div style={{ width: "50%", fontWeight: "bold", borderRight: "1px solid black", padding: "10px" }}>
                                Matching Ratio With Patient
                            </div>

                            <div style={{ width: "50%", fontWeight: "bold", padding: "10px" }}>
                                Matched Locus</div>
                        </div>

                        {MtableData?.length > 0 &&
                            MtableData?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                width: "95%",
                                                display: "flex",
                                                margin: "0px 0px",
                                                fontSize: "14px",
                                                height: "50px",
                                                textAlign: "center",
                                                marginLeft: "26px"
                                            }}
                                        >
                                            <div style={{ width: "50%", borderRight: "1px solid" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", textAlign: "center", marginTop: "15px" }}
                                                        value={list?.matchingratio}
                                                        onChange={(e: any) =>
                                                            updateMRow(index, "matchingratio", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div style={{ width: "50%" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "15px", textAlign: "center" }}
                                                        value={list?.Mismatchedlocus}
                                                        onChange={(e: any) =>
                                                            updateMRow(index, "Mismatchedlocus", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        </div>

                                    </>
                                );
                            })}


                    </table >
                    <div>
                        {resultdRemark1?.map((list: any, index: number) => {
                            return (

                                <div style={{
                                    padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px"
                                    , marginLeft: "25px"
                                }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ resize: "none", marginLeft: "0px", paddingTop: "4px", height: "40px", border: "1px solid black" }}
                                            rows={1}
                                            cols={137}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateMRemark(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>

                            )
                        })}
                    </div>

                    <div className="br1">.</div>

                    <div
                        style={{
                            width: "95%",
                            display: "flex",
                            alignItems: "center",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginTop: "-30px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{
                                                width: "100px",
                                                height: "60px",
                                                marginLeft: "60px",
                                            }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div
                        style={{
                            width: "98%",
                            display: "flex",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginLeft: "12px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{
                                                border: "none",
                                                resize: "none",
                                                textAlign: "center",
                                            }}
                                            rows={4}
                                            cols={130}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div className="main-content2">.</div>
                    {/* <div className="main-content3">.</div> */}
                    <div className="br1">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{hlaReport[0]?.designation}&nbsp;{hlaReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{hlaReport[0]?.pk}
                    </div>

                    {/* PATIENT APPENDIX */}
                    <div className="br">.</div>
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px", color: "white", background: "#640b66" }}>APPENDIX : PATIENT</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <table style={{ border: "1px solid black", width: "93%", marginLeft: "40px", height: "900px" }}>
                        <tr style={{ background: "#e8f8ff", color: "rgb(22 55 88)", height: "40px", display: "flex", border: "none" }}>
                            <th className="Table" style={{ textAlign: "left", width: "68%", padding: "10px", borderBottom: "1px solid", borderRight: "none" }}> Patient Name:&nbsp;&nbsp;{hlaReport[0]?.designation}&nbsp;{hlaReport[0]?.customer_name}
                                &nbsp;&nbsp;&nbsp;</th>
                            <th className="Table" style={{ textAlign: "left", width: "32%", padding: "10px", borderRight: "none" }}>
                                Patient Id:&nbsp;&nbsp;{hlaReport[0]?.pk}
                            </th>

                        </tr>

                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                textAlign: "center",
                                height: "35px",
                                padding: "4px",
                                borderBottom: "1px solid black",
                                margin: "10px 0px",



                            }}
                        >   <div style={{ width: "11%", fontWeight: "bold", marginLeft: "10px" }}>Locus</div>
                            <div style={{ width: "11%", fontWeight: "bold", }}>
                                G Code
                            </div>

                            <div style={{ width: "13%", fontWeight: "bold", }}>
                                NMDP Allele Code </div>

                            <div style={{ width: "15%", fontWeight: "bold" }}>
                                Exon Sequenced
                            </div>
                            <div style={{ width: "40%", fontWeight: "bold", marginLeft: "30px" }}>
                                Included Alleles
                            </div>

                        </div>

                        {patientAtableData?.length > 0 &&
                            patientAtableData?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                width: "95%",
                                                display: "flex",
                                                margin: "10px -10px",
                                                fontSize: "14px",
                                                height: "55px",
                                                textAlign: "center",
                                            }}
                                        >
                                            <div style={{ width: "11%", marginLeft: 8, height: "50px" }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "center", }}
                                                        value={list?.name}
                                                        onChange={(e: any) =>
                                                            updatePatientApendix(index, "name", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div style={{ width: "11%", marginLeft: 8 }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "center", }}
                                                        value={list?.g_code}
                                                        onChange={(e: any) =>
                                                            updatePatientApendix(index, "g_code", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "13%", marginLeft: 8, textAlign: "left" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", }}
                                                        value={list?.nmdpcode}
                                                        onChange={(e: any) =>
                                                            updatePatientApendix(index, "nmdpcode", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "15%", marginLeft: 8, textAlign: "left" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", }}
                                                        value={list?.se_quenced}
                                                        onChange={(e: any) =>
                                                            updatePatientApendix(index, "se_quenced", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "40%", marginLeft: 8, textAlign: "left" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{
                                                            border: "none",
                                                            resize: "none",
                                                            fontSize: "15px",
                                                            textAlign: "center",

                                                        }}
                                                        rows={2}
                                                        cols={58}
                                                        value={list?.includeallels}
                                                        onChange={(e) =>
                                                            updatePatientApendix(index, "includeallels", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}
                    </table>
                    <div className="br">.</div>
                    <div
                        style={{
                            width: "95%",
                            display: "flex",
                            alignItems: "center",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginTop: "20px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{
                                                width: "100px",
                                                height: "60px",
                                                marginLeft: "60px",
                                            }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div
                        style={{
                            width: "98%",
                            display: "flex",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginLeft: "12px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{
                                                border: "none",
                                                resize: "none",
                                                textAlign: "center",
                                            }}
                                            rows={4}
                                            cols={130}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div className="main-content2">.</div>
                    {/* <div className="main-content3">.</div> */}
                    <div className="br1">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{hlaReport[0]?.designation}&nbsp;{hlaReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{hlaReport[0]?.pk}
                    </div>
                    <div className="br">.</div>

                    {/* DONOR APPENDIX */}
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px", color: "white", background: "#098f91" }}>APPENDIX : DONOR</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <table style={{ border: "1px solid black", width: "93%", marginLeft: "40px", height: "900px" }}>
                        <tr style={{ background: "#e8f8ff", color: "rgb(22 55 88)", height: "40px" }}>
                            <th className="Table">
                                {donord1?.length > 0 &&
                                    donord1?.map((list: any, index: number) => {
                                        return (
                                            <>
                                                <div
                                                    style={{
                                                        width: "93%",
                                                        display: "flex",
                                                        margin: "10px -10px",
                                                        fontSize: "14px",
                                                        height: "30px",
                                                        textAlign: "left",
                                                        marginLeft: "0px"
                                                    }}
                                                >
                                                    <div style={{ width: "70%" }}>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;Donor Name:&nbsp; <input
                                                            style={{ border: "none", width: "60%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "left" }}
                                                            value={list?.name}
                                                            onChange={(e: any) =>
                                                                updateD1(index, "name", e.target.value, list)
                                                            }
                                                        />
                                                    </div>
                                                    <div style={{ width: "30%" }}>
                                                        &nbsp;&nbsp;&nbsp;&nbsp; Donor ID:&nbsp; <input
                                                            style={{ border: "none", width: "60%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "left" }}
                                                            value={list?.sampleid}
                                                            onChange={(e: any) =>
                                                                updateD1(index, "sampleid", e.target.value, list)
                                                            }
                                                        />

                                                    </div>


                                                </div>

                                            </>
                                        );
                                    })}
                            </th>
                        </tr>

                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                textAlign: "center",
                                height: "40px",
                                padding: "4px",
                                borderBottom: "1px solid black", marginLeft: "-30px",
                                margin: "10px 0px"


                            }}
                        >   <div style={{ width: "12%", fontWeight: "bold", }}>Locus</div>
                            <div style={{ width: "11%", fontWeight: "bold", }}>
                                G Code
                            </div>

                            <div style={{ width: "13%", fontWeight: "bold", }}>
                                NMDP Allele Code</div>

                            <div style={{ width: "15%", fontWeight: "bold", }}>
                                Exon Sequenced
                            </div>
                            <div style={{ width: "40%", fontWeight: "bold", }}>
                                Included Alleles
                            </div>

                        </div>
                        {donorAtableData?.length > 0 &&
                            donorAtableData?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <div
                                            style={{
                                                width: "95%",
                                                display: "flex",
                                                margin: "10px -10px",
                                                fontSize: "14px",
                                                height: "55px",
                                                textAlign: "center",
                                            }}
                                        >
                                            <div style={{ width: "13%", marginLeft: 8 }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.name}
                                                        onChange={(e: any) =>
                                                            updateDonorApendix(index, "name", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div style={{ width: "15%", marginLeft: 8 }}>
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.g_code}
                                                        onChange={(e: any) =>
                                                            updateDonorApendix(index, "g_code", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "15%", marginLeft: 8, textAlign: "left" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                        value={list?.nmdpcode}
                                                        onChange={(e: any) =>
                                                            updateDonorApendix(index, "nmdpcode", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "15%", marginLeft: 8, textAlign: "left" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <input
                                                        style={{ border: "none", width: "100%", background: "none", marginTop: "7px", textAlign: "center", }}
                                                        value={list?.se_quenced}
                                                        onChange={(e: any) =>
                                                            updateDonorApendix(index, "se_quenced", e.target.value, list)
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>
                                            </div>
                                            <div
                                                style={{ width: "47%", marginLeft: 8, textAlign: "center" }}
                                            >
                                                <GrammarlyEditorPlugin>
                                                    <textarea
                                                        style={{ border: "none", resize: "none", fontSize: "15px", textAlign: "center" }}
                                                        rows={2}
                                                        cols={58}
                                                        value={list?.includeallels}
                                                        contentEditable={true}
                                                        onChange={(e) =>
                                                            updateDonorApendix(
                                                                index,
                                                                "includeallels",
                                                                e.target.value,

                                                                list
                                                            )
                                                        }
                                                    />
                                                </GrammarlyEditorPlugin>

                                            </div>

                                        </div>

                                    </>
                                );
                            })}
                    </table>
                    <div className="br">.</div>
                    <div
                        style={{
                            width: "95%",
                            display: "flex",
                            alignItems: "center",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginTop: "20px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{
                                                width: "100px",
                                                height: "60px",
                                                marginLeft: "60px",
                                            }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div
                        style={{
                            width: "98%",
                            display: "flex",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginLeft: "12px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{
                                                border: "none",
                                                resize: "none",
                                                textAlign: "center",
                                            }}
                                            rows={4}
                                            cols={130}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div className="main-content2">.</div>
                    <div className="main-content3">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{hlaReport[0]?.designation}&nbsp;{hlaReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{hlaReport[0]?.pk}
                    </div>
                    <div className="br">.</div>

                    <div className="clinical__indicatio">
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            ABOUT HIGH RESOLUTION HLA TYPING
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="container" style={{ background: "none", border: "none", fontSize: "16px", marginLeft: "5px", width: "95%", wordWrap: "break-word", overflow: "auto" }}>
                        <ul>
                            <li>
                                <p>
                                    The Human Major Histocompatibility Complex, known as the "Human Leukocyte Antigen (HLA)", is the most gene-dense, polymorphic and disease-
                                    associated region of the human genome, especially class I and class II genes that are with a highly clustered and patchwork pattern of sequence motifs.
                                </p>

                            </li>
                            <li>
                                <p>
                                    NGS based high resolution HLA typing/matching is clinically relevant for hematopoietic stem cell transplantation, in order to differentiate
                                    serologically indistinguishable but functionally distinct HLA allelic products.
                                </p>
                            </li>
                            <li>
                                <p>
                                    The compatibility status of each patient/donor pair depends on the level of resolution of HLA typing and better the match lower the risk of post-
                                    transplant complications.
                                </p>
                            </li>
                            <li>
                                <p>
                                    G Code refers to HLA alleles that have identical nucleotide sequences across the exons encoding the peptide binding domains (exon 2 and 3 for HLA
                                    class I and exon 2 only for HLA class II alleles) but diﬀerent sequences across the introns that leads to ambiguous alleles. The included alleles for the
                                    relevant sample have been mentioned in the appendix. In case of no ambiguity, the same will be reflected in the appendix as “No ambiguity has been
                                    observed.”
                                </p>
                            </li>
                            <li>
                                <p>
                                    NMDP code is reported if the ambiguity is on the 2nd ﬁeld resolution.
                                </p>
                            </li>
                        </ul>
                    </div>
                    <br />
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            METHODOLOGY AND DATA ANALYSIS
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="container" style={{ background: "none", border: "none", fontSize: "16px", marginLeft: "10px", width: "95%", wordWrap: "break-word", overflow: "auto" }}>
                        <ul>
                            <li>
                                <p>
                                    PCR technology was used for locus specific amplification of HLA genes. Libraries were prepared and sequenced on Ion Torrent S5 plus as per the
                                    manufacturer's recommendation.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Data analysis was performed using NGSengine software (GenDx) to determine HLA genotype. Reagent information and other details are available
                                    upon request.
                                </p>
                            </li>
                        </ul>


                    </div>

                    {/* <div className="main-content2">.</div>
                    <div className="page2">.</div> */}

                    <div className="br">.</div>
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            SOFTWARE AND ALLELE DATABASE VERSION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {software?.map((list: any, index: number) => {
                            return (

                                <div style={{ padding: 15, textAlign: "left", marginTop: "-17px", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ marginLeft: "30px", paddingTop: "6px", border: "none", resize: "none" }}
                                            rows={2}
                                            cols={121}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateSoftware(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>

                            )
                        })}
                    </div>

                    <div className="main-content4">.</div>
                    <div
                        style={{
                            width: "95%",
                            display: "flex",
                            alignItems: "center",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginTop: "20px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{
                                                width: "100px",
                                                height: "60px",
                                                marginLeft: "60px",
                                            }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div
                        style={{
                            width: "98%",
                            display: "flex",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginLeft: "12px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{
                                                border: "none",
                                                resize: "none",
                                                textAlign: "center",
                                            }}
                                            rows={4}
                                            cols={130}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div className="main-content2">.</div>
                    <div className="main-content3">.</div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{hlaReport[0]?.designation}&nbsp;{hlaReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{hlaReport[0]?.pk}
                    </div>
                    <div className="br">.</div>
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            REFERENCES
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="conatiner" style={{ background: "none", border: "none", fontSize: "16px", marginLeft: "20px", width: "95%", wordWrap: "break-word", overflow: "auto" }}>
                        <ul>
                            <li>
                                <p>Erlich H. HLA DNA typing: past, present, and future. Tissue Antigens. 2012 Jul;80(1):1-11</p>
                            </li>
                            <li>
                                <p>Carapito R, Radosavljevic M, Bahram S. Next-Generation Sequencing of the HLA locus: Methods and impacts on HLA typing, populationgenetics
                                    and disease association studies. Hum Immunol. 2016 Nov;77(11):1016-1023.</p>
                            </li>
                            <li>
                                <p>Bodis G, Toth V, Schwarting A. Role of Human Leukocyte Antigens (HLA) in Autoimmune Diseases. Methods Mol Biol. 2018;1802:11-29.</p>
                            </li>
                            <li>
                                <p>Choo SY. The HLA system: genetics, immunology, clinical testing, and clinical implications. Yonsei Med J. 2007 Feb 28;48(1):11-23.</p>
                            </li>
                            <li>
                                <p>Tiercy JM. How to select the best available related or unrelated donor of hematopoietic stem cells? Haematologica. 2016Jun;101(6):680-7</p>
                            </li>
                        </ul>

                    </div>
                    <div className="br">.</div>

                    <div className="contain" style={{ border: "none", width: "93%", backgroundColor: "white", marginLeft: "20px", fontSize: "16px", }}>
                    </div>
                    <div style={{ marginLeft: "40px", width: "93%", fontSize: "16px", }}>
                        <p><b>CONFIDENTIAL:</b>This report may contain information that is privileged & conﬁdential. If you are not the intended recipient or have received it in error,
                            you are hereby notiﬁed that you may not use, copy, disclose, or distribute any information contained in the report and are requested to delete or
                            destroy all copies immediately</p>
                    </div>
                    <div style={{ marginLeft: "40px", fontSize: "16px", width: "93%", wordWrap: "break-word", wordBreak: "break-all" }}>
                        <p style={{ wordBreak: "break-word" }}><b>DISCLAIMER:</b>This test was developed and its performance characteristics determined by Redcliffe Life Science Pvt Ltd. It has not been cleared or
                            approved by the U.S.FDA. The test results are for RUO (research use only) and relate speciﬁcally to the sample received in the lab and are presumed
                            to have been collected and transported per speciﬁc instructions given by the physicians/laboratory and belongs to the patient named or identiﬁed in
                            the test requisition form. All reports have limitation imposed by sensitivity and speciﬁcity of the assay and should be interpreted in conjunction with
                            clinical presentation and other related investigations.
                            Results of this test could be aﬀected by interfering substances (endogenous and exogenous)/contamination during specimen collection, inappropriate
                            specimen storage and transport and thereby lead to occasional assay failure. The said report is strictly not a medical/medical laboratory/diagnostic
                            report and/or an opinion with regard to test results. The authorized signatories are only responsible for signing Technical report/Test report i.e a
                            report stating the test results and the processes, if any, indicating the analysis of sample without recording any medical opinion or diagnosis of any
                            medical condition</p>
                    </div>
                    <div className="main-content3">.</div>
                    {/* <div className="main-content3">.</div> */}
                    <div className="main-content4">.</div>
                    <div
                        style={{
                            width: "95%",
                            display: "flex",
                            alignItems: "center",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginTop: "20px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{
                                                width: "100px",
                                                height: "60px",
                                                marginLeft: "60px",
                                            }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div
                        style={{
                            width: "98%",
                            display: "flex",
                            padding: 0,
                            margin: 0,
                            justifyContent: "space-around",
                            marginLeft: "12px",
                        }}
                    >
                        {hladoctorList &&
                            hladoctorList?.length > 0 &&
                            hladoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{
                                                border: "none",
                                                resize: "none",
                                                textAlign: "center",
                                            }}
                                            rows={4}
                                            cols={130}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    {/* patient details page 2 end */}

                    {/* footer section starting */}
                    <div className="page-footer">
                        {/* footer area */}
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>genee@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <h5 style={{ marginLeft: "16px" }}>
                                            {" "}
                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </h5>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                    </div>
                       {
                                                uuid && (
                                                    <div className="hide-section-rating">
                                                        <NpsRating bookingId={firstP} uuid={uuid} />
                                                    </div>
                                                )
                                            }
                </div>
            </div >
        </Grammarly >
    );
};

const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(HlaReport);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}